"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.talkToSalesTypeSelector = exports.purchaseMotionsSelector = void 0;

var _PurchaseMotionTypes = require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _PurchaseMotionsLocations = require("pricing-pages-unified-ui/constants/PurchaseMotionsLocations");

var _ExperimentTreatmentSelectors = require("./ExperimentTreatmentSelectors");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var purchaseMotionsSelector = function purchaseMotionsSelector(state, location, merchId) {
  var isMon305Variant = (0, _ExperimentTreatmentSelectors.mon305VariantSelector)(state);
  var purchaseMotions = state.purchaseMotionsByLocation && state.purchaseMotionsByLocation[location] && state.purchaseMotionsByLocation[location].purchaseMotions[merchId];
  if (!purchaseMotions) purchaseMotions = []; // MON305 filtering out touchless for control

  if (!isMon305Variant && merchId === _MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL && purchaseMotions.length && location === _PurchaseMotionsLocations.MERCH_CARD) {
    return purchaseMotions.filter(function (motion) {
      return motion.key !== _PurchaseMotionTypes.BUY_TOUCHLESS;
    }).map(function (_ref) {
      var key = _ref.key;
      return key;
    });
  }

  return purchaseMotions.map(function (_ref2) {
    var key = _ref2.key;
    return key;
  });
};

exports.purchaseMotionsSelector = purchaseMotionsSelector;

var talkToSalesTypeSelector = function talkToSalesTypeSelector(state, hub) {
  var highlightedMerch = _HubMap.default[hub].highlightedPaidMerch;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = highlightedMerch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var merchId = _step.value;
      var purchaseMotions = purchaseMotionsSelector(state, _PurchaseMotionsLocations.EXTENDED_MERCH_CARD, merchId);
      if (purchaseMotions.includes(_PurchaseMotionTypes.TALK_TO_SALES)) return _PurchaseMotionTypes.TALK_TO_SALES;
      if (purchaseMotions.includes(_PurchaseMotionTypes.TALK_TO_SALES_FALLBACK)) return _PurchaseMotionTypes.TALK_TO_SALES_FALLBACK;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return _PurchaseMotionTypes.TALK_TO_SALES_FALLBACK;
};

exports.talkToSalesTypeSelector = talkToSalesTypeSelector;